module.exports = __webpack_public_path__ + "img/baofei.13240f36.jpg";